import { Facebook, Link2, Mail, MessageSquare } from "lucide-react";
import { toast } from "sonner";

const btn = "inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm transition-colors";

export const ShareButtons = ({ title, message, path, dark = false, testId = "share" }) => {
  const url = `${window.location.origin}${path}`;
  const body = `${message} ${url}`;
  const tone = dark ? "border-mist/40 text-sage hover:bg-sage hover:text-pine" : "border-pine/30 text-pine hover:bg-pine hover:text-sage";
  const links = [
    { key: "text", label: "Text", Icon: MessageSquare, href: `sms:?&body=${encodeURIComponent(body)}` },
    { key: "email", label: "Email", Icon: Mail, href: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(body)}` },
    { key: "facebook", label: "Facebook", Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, external: true },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied. Paste it anywhere to share.");
    } catch {
      toast.error("Couldn't copy the link. You can copy it from the address bar.");
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3" data-testid={`${testId}-buttons`}>
      <span className={`lb ${dark ? "text-mist" : "text-brass-ink"}`}>Share with a friend</span>
      {links.map(({ key, label, Icon, href, external }) => (
        <a key={key} href={href} className={`${btn} ${tone}`} data-testid={`${testId}-${key}`}
          {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}>
          <Icon size={15} /> {label}
        </a>
      ))}
      <button type="button" onClick={copy} className={`${btn} ${tone}`} data-testid={`${testId}-copy`}>
        <Link2 size={15} /> Copy link
      </button>
    </div>
  );
};
